import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }




export const addPermissionAction = createAsyncThunk(
    'add-permission',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/support-server/api/add-permission`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const addPermissionSlice = createSlice({
    name: 'add-permission',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(addPermissionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(addPermissionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(addPermissionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const addPermissionReducer = addPermissionSlice.reducer